/* eslint-disable max-len */
import React from 'react'
import {connect} from 'react-redux'

import {signOut} from '../actions/signOut'

import {Icon} from '@lazarusai/forms-ui-components'

import stylesLogOut from '../styles/LogOut.module.css'

function LogOut(props) {
  return (
    <>
      <div
        onClick={() => props.signOut()}
        className={`${stylesLogOut['log-out-icon-wrapper']}`}
        title='Sign Out'
      >
        <Icon
          icon={'log-out-outline'}
        />
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  messageHistory: state.userReducer.messageHistory,
})

export default connect(
    mapStateToProps,
    {signOut},
)(LogOut)
